export { FontSizes } from '@fluentui/theme';
